/**
 *  订单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchData"  ref="searchForm" class="user-search"   >
      <el-form-item label="手机号码" prop="phone" >
        <el-input size="small" v-model="searchData.phone" placeholder="输入手机号" ></el-input>
      </el-form-item>
      <el-form-item label="抖音订单号" prop="order_no" v-if="role_id!=16">
        <el-input size="small" v-model="searchData.order_no" placeholder="输入抖音订单号"></el-input>
      </el-form-item>

       <el-form-item label="宽带账号" prop="account" >
        <el-input size="small" v-model="searchData.account" placeholder="支持 '空' 字查询"></el-input>
       
      </el-form-item>
         <el-form-item label="下单日期" prop="daterange" v-if="role_id!=16">
          <el-date-picker
          v-model="searchData.daterange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
    </el-date-picker>
      </el-form-item>
    <el-form-item label="业务员" prop="salesman" v-if="role_id!=16">
        <el-select v-model="searchData.salesman" placeholder="请选择业务员" >
            <el-option  v-for="(items,index) in salesmanList"   :key="index"  :label="items.name"  :value="items.userId"></el-option>
          </el-select>
      </el-form-item>
    <!-- <el-form-item label="归属地" prop="belong">
        <el-select v-model="searchData.belong" placeholder="请选择归属地" >
            <el-option  v-for="(items,index) in belongs"   :key="index"  :label="items.name"  :value="items.id"></el-option>
          </el-select>
      </el-form-item> -->
          <el-form-item label="供应商" prop="provide" v-if="role_id!=16">
        <el-select v-model="searchData.provide" placeholder="请选择供应商" >
            <el-option  v-for="(items,index) in provides"   :key="index"  :label="items.name"  :value="items.id"></el-option>
          </el-select>
      </el-form-item>
          <!-- <el-form-item label="部门" prop="department"  v-if="showDepartment">
        <el-select v-model="searchData.department" placeholder="请选择部门" >
            <el-option  v-for="(items,index) in departmentData"   :key="index"  :label="items.name"  :value="items.id"></el-option>
          </el-select>
      </el-form-item> -->

    <el-form-item label="订单状态" prop="status" v-if="role_id!=16">
        <el-select v-model="searchData.status"  placeholder="订单状态" >
            <el-option  v-for="(items,index) in  statusList"   :key="index"  :label="items.name"  :value="items.code"></el-option>
          </el-select>
      </el-form-item>
      <!-- <el-form-item>
         <el-form-item label="到期日期" prop="expires_times" v-if="role_id!=16">
          <el-date-picker
          v-model="searchData.expires_times"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
    </el-date-picker>
      </el-form-item> -->

    <el-form-item label="模糊查询" prop="fuzzy_search_data" v-if="role_id!=16">
        <el-input size="small" v-model="searchData.fuzzy_search_data"  @focus="searchHander" placeholder="输入安装地址/姓名/手机"></el-input>
      </el-form-item>
    <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row   v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" :cell-style="cellStyle">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column sortable   align="center" prop="type" label="宽带类型" width="50">
      </el-table-column>
      <el-table-column sortable   align="center" prop="mbps" label="宽带兆数" width="80">
      </el-table-column>
       <el-table-column sortable align="center" prop="u_name" label="客户名称" width="60">
         <template slot-scope="scope">
          <div @click="infoAlter(scope.row.order_no)">{{scope.row.u_name}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable align="center" prop="phone" label="手机号码" width="100">
      </el-table-column>
      <el-table-column sortable align="center" prop="order_no" label="抖音订单号" width="150">
      </el-table-column>
      <el-table-column sortable align="center" prop="group_id" label="集团ID" width="100">
      </el-table-column>
         <el-table-column sortable align="center" prop="express_order_number" label="快递单号" width="100">
      </el-table-column>
        <!-- <el-table-column sortable align="center" prop="belong" label="归属地" width="100">
      </el-table-column> -->
         <el-table-column sortable align="center" prop="provide" label="供应商" width="100">
      </el-table-column>
        <!-- <el-table-column sortable align="center" prop="group_name" label="集团名称" width="100">
      </el-table-column> -->
      <el-table-column sortable align="center" prop="account" label="宽带账号" width="100">
      </el-table-column>
      <el-table-column sortable align="center" prop="place" label="安装地址" width="150">
      </el-table-column>
      <el-table-column sortable align="center" prop="money" label="金额" width="50" v-if="role_id!=16">
      </el-table-column>
      <el-table-column sortable align="center" prop="salesmanName" label="业务员" width="60" v-if="role_id!=16">
      </el-table-column>
      <el-table-column sortable align="center" prop="order_time" label="下单时间" width="150">
      </el-table-column>
      <el-table-column sortable align="center" prop="expires_times" label="到期时间" width="100" v-if="role_id!=16">
      </el-table-column>
      <el-table-column sortable align="center" prop="handler" label="录单员" width="80" v-if="role_id!=16">
      </el-table-column>
        <el-table-column sortable align="center" prop="status" label="状态" width="150">
          <template slot-scope="scope">
        <!-- <el-tag
          :type="statusStyle(scope.row.status)"
          disable-transitions>{{StateToStr(scope.row.status)}}</el-tag> -->
          <el-tag
          :type="statusStyle(scope.row.status)"
          disable-transitions>{{scope.row.StatusInfo}}</el-tag>
      </template>
      </el-table-column>
    <el-table-column sortable align="center" prop="desc" label="备注" width="80">
      </el-table-column>
        <el-table-column sortable  align="center" prop="create_time" label="创建时间" width="150">
      </el-table-column>
        <!-- <el-table-column sortable  align="center" prop="update_time" label="更新时间" width="150">
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="220">
        <template slot-scope="scope">
          <div v-if="scope.row.isLock==1||isLock">
            <!-- <el-button  v-if="role_id==16" size="mini" @click="handleEdit(scope.$index, scope.row)">状态</el-button> -->
            <!--供应商选择状态开始-->
              <el-select   v-if="role_id==16"  v-model="pro_status_value"  placeholder="请选择宽带状态"  @change="Pro_changeStatus($event,scope.row.id)">
                  <el-option
                    v-for="item in statusList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
            </el-select>
            <!--供应商选择状态结束-->
            <el-button size="mini"  v-if="role_id!=16" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" v-if="isLock&&scope.row.isLock==1" @click="Lock(scope.row.id)">锁定</el-button>
          <el-button size="mini" v-if="isLock&&scope.row.isLock==2" @click="unLock(scope.row.id)">解锁</el-button>
          <el-button v-permission="'Delete_Order'"  size="mini" type="danger" @click="deleteOrder(scope.row.id)">删除</el-button>
          </div>
          <div v-else class="tips">
            已锁定
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!--编辑-->
     <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
          <el-form ref="ruleForm" :model="editForm" :rules="rules"  label-width="80px"  class="form" >
          <el-form-item label="客户姓名" prop="u_name" class="s_input" :disabled="isAbled">
          <el-input v-model="editForm.u_name"></el-input>
        </el-form-item>

   <el-form-item label="联系方式"  prop="phone" class="s_input">
    <el-input v-model="editForm.phone" :disabled="isAbled"></el-input>
  </el-form-item>

   <el-form-item label="供应商" prop="provide">
    <el-select v-model="editForm.provide" placeholder="请选择宽带供应商"  :disabled="isAbled">
      <el-option  v-for="(item,i) in provides"  :key="i" :label="item.name"  :value="item.id"></el-option>
  
    </el-select>
  </el-form-item> 

 <!-- <el-form-item label="归属地" prop="belong">
    <el-select v-model="editForm.belong" placeholder="请选择宽带归属地" :disabled="isAbled">
      <el-option  v-for="(item,i) in belongs"  :key="i" :label="item.name"  :value="item.id"></el-option>
  
    </el-select>
  </el-form-item>  -->


  <el-form-item label="宽带类型" prop="type">
    <el-select v-model="editForm.type" placeholder="请选择宽带类型"  @change="handleChange" :disabled="isAbled">
      <el-option   v-for="(item,key)  in typeData"   :key="key"  :label="item.name" :value="item.id"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="宽带套餐" prop="mbps">
    <el-select v-model="editForm.mbps" placeholder="请选择宽带套餐" :disabled="isAbled">
      <el-option   v-for="(item,i) in mbpsData"   :key="i" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </el-form-item>


  <el-form-item label="安装地址"  prop="place" >
    <el-input v-model="editForm.place" :disabled="isAbled"></el-input>
  </el-form-item>

   <el-form-item label="快递单号"  prop="express_order_number" >
    <el-input v-model="editForm.express_order_number" :disabled="isAbled"></el-input>
  </el-form-item>


   
    <el-form-item label="集团ID"  prop="group_id" class="s_input">
    <el-input v-model="editForm.group_id" ></el-input>
  </el-form-item>

        <!-- <el-form-item label="集团名称"  prop="group_name" class="s_input">
        <el-input v-model="editForm.group_name"></el-input>
      </el-form-item> -->
  <el-form-item label="宽带账号" prop="account" class="s_input">
    <el-input v-model="editForm.account"></el-input>
  </el-form-item>
   <el-form-item label="抖音订单号" prop="order_no"   v-if="showOrderId" class="s_input">
    <el-input v-model="editForm.order_no"></el-input>
  </el-form-item>
   <el-form-item label="下单时间" prop="order_time" class="s_input">
      <el-date-picker
      v-model="editForm.order_time"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择下单日期">
    </el-date-picker>
  </el-form-item>

    <el-form-item label="金额" prop="money" class="s_input" v-if="role_id!=16">
    <el-input v-model="editForm.money"></el-input>
  </el-form-item>
  <el-form-item label="到期时间" prop="expires_times" class="s_input">
        <el-date-picker
          v-model="editForm.expires_times"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择到期日期">
        </el-date-picker>
    </el-form-item>

   <el-form-item label="业务员" prop="salesman" v-if="role_id!=16">
    <el-select v-model="editForm.salesman" placeholder="请选择业务员"  :disabled="isCheck">
       <el-option  v-for="(items,index) in salesmanList"   :key="index"  :label="items.name"  :value="items.userId"></el-option> 
    </el-select>
  </el-form-item>

  <el-form-item label="订单状态">
    <el-select v-model="editForm.status" placeholder="订单未选择">
      <el-option :label="items.name" :value="items.code"  :key="items.id" v-for="items  in statusList "></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="备注">
    <el-input type="textarea" v-model="editForm.desc"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm')">立即提交</el-button>
    <el-button @click="closeDialog">取消</el-button>
  </el-form-item>
</el-form>



     </el-dialog>


  </div>
</template>

<script>
import Vue from 'vue';
import clipboard from 'clipboard';
import { addOrder,listOrder,oderById,salesmanList,search,editOrder,getMealData,
getTypeData,getprovide,getbelong,getStatus,get_role,handlock,
handUnlock,OverdueNum,deleteOrder,editStatus,getcard_info} from '../../api/order'
import Pagination from '../../components/Pagination'
import ExportJsonExcel from "js-export-excel"
export default {
  data() {
    return {
       
            showStatus:false,
            role_id:0,
            isSearchMenu:true,
            isLock:false,
            showDepartment:false,
            showOrderId:true,
            isAbled:true,//是否可以编辑
            isCheck:true,//是否可以选择业务员
            typeData:[],
          //  belongs:[],
            provides:[],
            mbpsData:[],
            statusList:[],
            departmentData:[
              {id:100,name:'全部'},
              {id:10,name:'直播组'},
              {id:15,name:'市场部'},
              ],
      salesmanList:[],
      pro_status_value:"",//供应商的状态选择
      mbpsIndex:0,
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '编辑宽带订单',
      show: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      isSearch:false,//是否是搜索模式
      searchData:{
        phone:'',
        order_no:'',
        daterange:'',
        salesman:'',
        status:'',
        expires_times:'',
        department:'',//部门
        fuzzy_search_data:"",//模糊查询
        account:""//宽带账号查询出现空字就是查询

      },
      editForm:{
                u_name:'',
                type:'',
                mbps:'',
                place:'',
                group_id:'',
                account:'',
                order_no:'',
                salesman:'',
                phone:'',
                money:'',
                desc:'',
                expires_times:'',
                group_name:'',
                order_time:'',
                provide:0,
                //belong:0,
                status:3,
                express_order_number:'',

            },
             rules: {

              u_name:[
                 { required: true, message: '请输入客户姓名', trigger: 'blur'}
              ],
              type:[
                 { required: true, message: '请选择宽带类型', trigger: 'blur'}
              ],
              mbps:[
                 { required: true, message: '请选择宽带兆数', trigger: 'blur'}
              ],
              place:[
                 { required: true, message: '填写宽带安装地址', trigger: 'blur'}
              ],
                  provide:[
                 { required: true, message: '供应商不能为空', trigger: 'blur'}
              ],
              //  belong:[
              //    { required: true, message: '归属地不能为空', trigger: 'blur'}
              // ],
              //  group_id:[
              //    { required: true, message: '集团ID不能为空', trigger: 'blur'}
              // ],
              //  account:[
              //    { required: true, message: '宽带账号不能为空', trigger: 'blur'}
              // ],
                order_no:[
                 { required: true, message: '抖音订单号为空', trigger: 'blur'}
              ],
              //   salesman:[
              //    { required: true, message: '请选择业务员', trigger: 'blur'}
              // ],
              
                phone: [
                  { required: true, message: '请输入手机号码', trigger: 'blur' },
                  { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式错误', trigger: 'blur' }
                ],
                money: [
                  { required: true, message: '请输入金额', trigger: 'blur' },
                  //{ pattern: /^[\d]+$/, message: '金额必须是整数', trigger: 'blur' }
                ],

        },
      formInline: {
        page: 1,
        limit: 10,
      },
 
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    this.init();
    try{
       var  promisea=this.asyncFn().then(res=>{
        console.log('等一天额');
       });
      // console.log(res);
    }catch(err){
        console.log('err');
    }
   
  },

  watch:{
      '$route.query': {
      immediate: true,
      handler(newQuery) {
        this.formInline.page=1;
        this.getdata(this.formInline);
      }
    }
  },
  computed:{
    queryParam(){
      
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

   // 异步promise化的函数--模拟请求后端接口
 async asyncFn () {
    let pro= await new Promise(function (resolve, reject) {
    setTimeout(function () {
      if (true) {
        console.log('resolve console')
        resolve('resolve return')
      } else {
        reject('reject return')
      }
    }, 5000)
  })
 // return pro;
 // console.log("什么时候到我");
},

    //点击名字弹出用户信息

    infoAlter(order_no){
   
        let user_card={};
         user_card['order_id']=order_no;
        //    console.log(user_card);
        getcard_info(user_card).then(res=>{
         // console.log(res);
              let html_str='身份证件号:'+res['data']['card_no']+'\r\n证件姓名:'+res['data']['card_name'];
                  this.$alert(html_str, '身份信息', {
                dangerouslyUseHTMLString: true,
                confirmButtonText:'复制',
                callback: action => {
                  this.copyHtmlContent(html_str)
                    this.$message('复制成功');
                  }
          });
        })
    
  
    },
    copyHtmlContent(html) {
   // var content = document.getElementById('content').innerHTML;
    var tempElement = document.createElement('textarea');
    tempElement.value = html; // 设置文本内容
    document.body.appendChild(tempElement);
    tempElement.select(); // 选中元素
    document.execCommand('copy'); // 执行复制操作
    document.body.removeChild(tempElement); // 移除临时元素
    //alert('HTML内容已复制到剪贴板。');
},

    //获取超期的统计数字
      getOverdueNum(){
        OverdueNum().then(res=>{
          this.$root.Bus.$emit('overdue',res.data)
        })
      },

      //模糊查询的操作，清空搜索数据
      searchHander(){
        for (const key in this.searchData) {
              this.searchData[key]="";
        }
       // console.log(this.searchData);
      },
      reset(){
         this.$refs['searchForm'].resetFields();
         this.formInline.page=1;
        this.search();
      },
      cellStyle(row,column,rowIndex,columnIndex){
              if(row.row.isLock===1){
                //  return 'background:#f5f7fa;color:#c0c4cc';
              }else{
                 return 'background:#f5f7fa;color:#c0c4cc';
              }
      },
      unLock(id){
         handUnlock(id).then(res=>{
            this.getdata(this.formInline);
        })
      },
      Lock(id){
        handlock(id).then(res=>{
            this.getdata(this.formInline);
        })
      },
       init(){
          salesmanList().then(res=>{
              this.salesmanList=res.data;
              });
            getTypeData().then(res=>{
            //console.log(res);
              this.typeData=res.data
            })
              getprovide().then(res=>{
              this.provides=res.data
            })
            //   getbelong().then(res=>{
            //   this.belongs=res.data
            // })
            getStatus().then(res=>{
              this.statusList=res.data
            })
            this.isSalesperson();
            this.isEdit();
            this.get_role();
            this.getOverdueNum();//获取
            
        },
          get_role(){
            get_role().then(res=>{
              this.role_id=res.data;
              if(res.data==10){
                this.showOrderId=true
              }else if(res.data==15){
                this.showOrderId=false;
              }else if(res.data==12){
                this.isLock=true;
                this.showDepartment=true;//管理员可以按照部门查询
              }else if(res.data==16){//供应商
                this.isSearchMenu=false;
               
              }
            })
      },
      changeStatus(val){
        this.searchData.status=val;
      },
      Pro_changeStatus(status,id){
          this.pro_status_value="";
          this.$confirm('此操作将修改订单状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params={
            id,
            status
          }
          editStatus(params).then(res=>{
              if(res.code==200){
                this.$message({
                type: 'success',
                message: '修改状态成功!'
                });
                 this.searchPage()
              }
            })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改'
          });          
        });
      },
      isSalesperson(){
          let permission=localStorage.getItem('permission');
              if(permission){
                if(permission.includes('all')||permission.includes('Modify_salesperson')){//包含选择业务员权限
                  this.isCheck=false;
               }else{
                  this.isCheck=true;
               }
              }
      },
        isEdit(){
          let permission=localStorage.getItem('permission');
              if(permission){
                if(permission.includes('all')||permission.includes('Edit_order')){//包含选择业务员权限
              //  console.log("业务员");
                  this.isAbled=false;
               }else{
                  this.isAbled=true;
               }
              }
  
      },
     
      handleChange(id){
          getMealData(id).then(res=>{
            this.editForm.mbps='';
            this.mbpsData=res.data;
      })

      },
      isNumber(str) {
      return /^\d+$/.test(str);
    },
      changeSalesman(val){
        this.searchData.salesman=val;
      },
      
      oderById(id){
        oderById(id).then(res=>{
          if(res.data.hasOwnProperty('handler')){
            delete res.data['handler'];
          }
         var info=res.data; //处理数据类型不正确
            info['type']=this.isNumber(info['type'])?parseInt(info['type']):info['type'];
            info['mbps']=this.isNumber(info['mbps'])?parseInt(info['mbps']):info['mbps'];
            this.getMeal(info['type']);
            this.editForm=info;

        })
      },
      getMeal(id){
        if(this.isNumber(id)){
          getMealData(id).then(res=>{
            //this.editForm.mbps='';
            this.mbpsData=res.data;
            })
        }
         
      },

        //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑宽带订单'
        this.oderById(row.id);
      } else {
        this.title = '添加'
        
      }
    },
    statusStyle(status){
      if(status==1){
        return 'success';
      }else if(status==0||status==3){
          return 'info';
      }else{
        return 'danger';
      }
      
    },
    StateToStr(status){
      if(status==1){
        return '安装完成已核销';
      }else if(status==0){
        return '未安装未核销';
      }else if(status==2){
        return '安装成功未核销';
      }else if(status==3){
        return '未安装未核销';
      }
      else if(status==4){
        return '已退单';
      }
       else if(status==5){
        return '需要上门开卡';
      }
       else if(status==500){
        return '异常订单';
      }
      else{
        return '未知状态';
      }
    }, 
    // 获取订单列表
    getdata(parameter) {
      this.loading = true
     let query= this.$route.query;
    //console.log(Object.keys(query).length);   
     if(Object.keys(query).length!==0){ 
        parameter.act=query.do;
     }
     
     //console.log(parameter);
      listOrder(parameter).then(res=>{
      this.loading = false
      this.listData = res.data
      this.pageparm.currentPage = this.formInline.page
      this.pageparm.pageSize = this.formInline.limit
      this.pageparm.total = res.count
      if(parameter.hasOwnProperty('act')){
          Vue.delete( parameter, 'act' );
          this.$root.Bus.$emit('overdue',res.count);
      }

      })
     
      
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      if(this.isSearch){
          this.searchPage();
      }else{
        this.getdata(this.formInline)
      }
      
    },

    searchPage(){
      this.searchData.currentPage = this.formInline.page
      this.searchData.pageSize = this.formInline.limit
      search(this.searchData).then(res=>{
        this.listData = res.data.data;
        this.pageparm.total = res.data.total;
       
      });
    },
    // 搜索事件
    search() {
      this.isSearch=true;
     // this.formInline.page=1;
      this.pageparm.currentPage=1;
      this.searchData.currentPage = 1;
      search(this.searchData).then(res=>{
        this.listData = res.data.data;
        this.pageparm.total = res.data.total;
       
      })
    },
  //删除订单
    deleteOrder(id){
         this.$confirm('此操作将删除该订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
           deleteOrder(id).then(res=>{
            this.getdata(this.formInline)
             this.$message({
                type: 'success',
                message: '删除成功!'
               });
              }) 
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
       
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          editOrder(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code==200) {
                 if(this.isSearch){
                      this.searchPage();
                  }else{
                    this.getdata(this.formInline)
                  }
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('稍后尝试')
            })
        } else {
          return false
        }
      })
    },
    // 缴费失败
    handlFail(index, row) {
      
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  width: 1200px;
}
.userRole {
  width: 100%;
}
.seal{
	width: 60rpx;
	height: 60rpx;
	border: solid 6rpx #B4B4B4;
	border-radius: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}
.seal-son{
	width: 45rpx;
	height: 45rpx;
	border: solid 2rpx #B4B4B4;
	border-radius: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	position: relative;
}
.tips{

  font-size: 12px;
  color: #ccc;
  display: inline-block;
}


</style>

 
 


// WEBPACK FOOTER //
// src/views/order/order.vue